import ItodoImage from "../../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { blogPosts } from "../../../../globals/neuron-content";

function SectionBlogs1() {
  return (
    <div className="section-full p-t110 p-b80 sx-bg-white sx-latest-blog-outer wow fadeInDown" data-wow-duration="1000ms">
      <div className="container">
        <div className="section-head center">
          <div className="sx-head-s-title">Company Insights</div>
          <div className="sx-head-l-title"><h2 className="sx-title">Latest Security Briefs</h2></div>
        </div>
        <div className="section-content">
          <div className="owl-carousel sx-latest-blog-1-carousel m-b30">
            {blogPosts.slice(0, 6).map((post) => (
              <div className="item" key={post.title}>
                <div className="sx-latest-post-st-1">
                  <div className="sx-post-media sx-img-effect img-reflection"><NavLink to={`/insights/${post.slug}`}><ItodoImage src={post.image} alt={post.title} /></NavLink></div>
                  <div className="sx-post-info p-t30">
                    <div className="sx-post-meta"><ul><li className="post-date"><NavLink to={`/insights/${post.slug}`}><i className="fa fa-calendar" />{post.date}</NavLink></li><li className="post-author"><NavLink to={`/insights/${post.slug}`}><i className="fa fa-comments" />{post.comments} Comments</NavLink></li></ul></div>
                    <div className="sx-post-title"><h4 className="post-title"><NavLink to={`/insights/${post.slug}`}>{post.title}</NavLink></h4></div>
                    <div className="sx-post-readmore"><NavLink to={`/insights/${post.slug}`} title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa fa-long-arrow-right" />Read More</NavLink></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionBlogs1;
